"use client"

import { useBranches } from "@/hooks/use-branches"
import BranchGrid from "@/components/branch-grid"
import BranchGridSkeleton from "@/components/branch-grid-skeleton"
import { AlertCircle, RefreshCcw } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function BranchGridContainer() {
  const { data: branches = [], isLoading, error, refetch } = useBranches()
  const { t } = useTranslation()

  if (isLoading) {
    return <BranchGridSkeleton />
  }

  if (error) {
    return (
      <div className="px-2 md:px-4 py-12 w-full max-w-7xl mx-auto animate-fade-in-up">
        <div className="rounded-3xl bg-white shadow-sm border border-gray-100 p-8 text-center">
          <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle size={32} />
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">{t("failedToLoadBranches")}</h3>
          <p className="text-gray-500 mb-6 max-w-xs mx-auto">
            {t("errorFetchingLocations")}
          </p>
          <button 
            onClick={() => refetch()} 
            className="inline-flex flex items-center gap-2 px-5 py-2 bg-pink-600 text-white rounded-full shadow-xl shadow-pink-200 hover:shadow-2xl hover:shadow-pink-300 hover:bg-pink-700 hover:-translate-y-1 transition-all duration-300 active:scale-95"
          >
            <RefreshCcw size={16} />
            {t("retry")}
          </button>
        </div>
      </div>
    )
  }

  if (branches.length === 0) {
    return (
      <div className="px-3 md:px-4 py-12 w-full max-w-7xl mx-auto animate-fade-in-up">
        <div className="rounded-3xl bg-white shadow-sm border border-gray-100 p-8 text-center">
          <div className="w-16 h-16 bg-gray-50 text-gray-400 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle size={32} />
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">{t("No branches found")}</h3>
          <p className="text-gray-500 mb-6 max-w-xs mx-auto">
            {t("We couldn't find any available branches at the moment.")}
          </p>
        </div>
      </div>
    )
  }

  return <BranchGrid branches={branches} />
}

